import {
    createAsyncThunk,
    createSlice,
} from '@reduxjs/toolkit';

import {
    add,
    deleteRecord,
    fetch,
    fetchRecords,
    update,
} from '../services/UserProfileAttributesService.ts';


import {
    deleteOneCase,
    fetchManyCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from '../../../../store/RecordsSliceCaseHelpers';
import {moduleConfig} from "../config";
import {
    UserProfileAttribute,
    UserProfileAttributesState
} from "../types.ts";

const entityKey = moduleConfig.entityKey;


const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
} as UserProfileAttributesState;


const normalizeRecord = (record: UserProfileAttribute) => {
    return Object.assign({}, record, {
        id: record.name,
    });
};

// generates pending, fulfilled and rejected
export const fetchUserProfileAttributes = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    () => {

        return fetchRecords()
            .then((response) => {
                if (response) {
                    return response.map((record: UserProfileAttribute) => {
                        return normalizeRecord(record);
                    });
                }
            });
    },
);

export const fetchUserProfileAttribute = createAsyncThunk(
    `${entityKey}/fetch`,
    (id: string) => {
        return fetch(id)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response as UserProfileAttribute);
                }
            });
    });

export const saveUserProfileAttribute = createAsyncThunk(
    `${entityKey}/add`,
    ({
         payload
     }: { payload: UserProfileAttribute }) => {

        return add(payload)
            .then((response) => {
                if (response) {
                    return normalizeRecord(response);
                }
            });
    });

export const updateUserProfileAttribute = createAsyncThunk(
    `${entityKey}/update`,
    ({
         id,
         record,
     }: { id: string, record: UserProfileAttribute }) => {

        return update(id, record)
            .then((response) => {
                if (response) {
                    return normalizeRecord(record);
                }
            });
    },
);

export const deleteUserProfileAttribute = createAsyncThunk(
    `${entityKey}/deleteRecord`,
    (id: string) => {
        return deleteRecord(id)
            .then(() => id);
    },
);


const componentsSlice = createSlice({
                                        name: entityKey,
                                        initialState,
                                        reducers: {
                                            clearState: () => initialState,
                                        },
                                        extraReducers: (builder) => {
                                            // FETCH MANY
                                            fetchManyCase(builder, fetchUserProfileAttributes, entityKey);

                                            // FETCH ONE
                                            fetchOneCase(builder, fetchUserProfileAttribute);

                                            // SAVE ONE
                                            saveOneCase(builder, saveUserProfileAttribute);

                                            // UPDATE ONE
                                            updateOneCase(builder, updateUserProfileAttribute);

                                            // DELETE ONE
                                            deleteOneCase(builder, deleteUserProfileAttribute);
                                        },
                                    });

export default componentsSlice.reducer;
